"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var Translation_1 = require("../../../../common/components/presentation/Translation/Translation");
var ShowIfTranslationExists_1 = require("../../../../common/components/ShowIfTranslationExists");
var inStorePaymentStyles_1 = require("./inStorePaymentStyles");
var InStorePaymentForm_1 = require("../../../../gql/commonSteps/inStorePaymentForm/components/inStorePaymentForm/InStorePaymentForm");
var InStorePayment = function () {
    var styles = inStorePaymentStyles_1.default();
    return (<core_1.Box className={styles.root} data-test="checkout:payment_in_store">
      <ShowIfTranslationExists_1.default translationKey="trans__se__instore_payment__title">
        <core_1.Typography className={styles.label}>
          <Translation_1.default id="trans__se__instore_payment__title"/>
        </core_1.Typography>
      </ShowIfTranslationExists_1.default>
      <InStorePaymentForm_1.default />
    </core_1.Box>);
};
exports.default = InStorePayment;
